import { takeEvery, call, put } from "redux-saga/effects";
import {
  GENERATE_AD_CREATIVE_REQUEST,
  GENERATE_AD_CREATIVE_SUCCESS,
  GENERATE_AD_CREATIVE_FAILURE,
  PUBLISH_AD_CREATIVE_REQUEST,
  PUBLISH_AD_CREATIVE_SUCCESS,
  PUBLISH_AD_CREATIVE_FAILURE,
  TRIGGER_ART_DEPT_REQUEST,
  TRIGGER_ART_DEPT_SUCCESS,
  TRIGGER_ART_DEPT_FAILURE,
  TRIGGER_AD_VIDEO_REQUEST,
  TRIGGER_AD_VIDEO_SUCCESS,
  TRIGGER_AD_VIDEO_FAILURE,
  TRIGGER_GOOGLE_ADS_CAMPAIGN_REQUEST,
  TRIGGER_GOOGLE_ADS_CAMPAIGN_SUCCESS,
  TRIGGER_GOOGLE_ADS_CAMPAIGN_FAILURE,
  PUBLISH_GOOGLE_AD_REQUEST,
  PUBLISH_GOOGLE_AD_SUCCESS,
  PUBLISH_GOOGLE_AD_FAILURE,
  GET_GOOGLE_AD_STATUS_REQUEST,
  GET_GOOGLE_AD_STATUS_SUCCESS,
  GET_GOOGLE_AD_STATUS_FAILURE,
  GOOGLE_ADS_OAUTH_CALLBACK_REQUEST,
  GOOGLE_ADS_OAUTH_CALLBACK_SUCCESS,
  GOOGLE_ADS_OAUTH_CALLBACK_FAILURE,
} from "../actions/advertisingAgentActions";
import {
  generateAdCreativeApi,
  publishAdCreativeApi,
  triggerArtDeptApi,
  triggerAdVideoApi,
  triggerGoogleAdsCampaignApi,
  publishGoogleAdApi,
  getGoogleAdStatusApi,
  googleAdsOAuthCallbackApi,
} from "../apis/advertisingAgentApi";

function* generateAdCreativeSaga(action) {
  try {
    const result = yield call(generateAdCreativeApi, action.payload);
    yield put({ type: GENERATE_AD_CREATIVE_SUCCESS, payload: result });
  } catch (error) {
    yield put({ type: GENERATE_AD_CREATIVE_FAILURE, error: error.message });
  }
}

function* publishAdCreativeSaga(action) {
  try {
    const result = yield call(publishAdCreativeApi, action.payload);
    yield put({ type: PUBLISH_AD_CREATIVE_SUCCESS, payload: result });
  } catch (error) {
    yield put({ type: PUBLISH_AD_CREATIVE_FAILURE, error: error.message });
  }
}

function* triggerArtDeptSaga(action) {
  try {
    const result = yield call(triggerArtDeptApi, action.payload);
    yield put({ type: TRIGGER_ART_DEPT_SUCCESS, payload: { ...result, campaignId: action.payload.campaignId } });
  } catch (error) {
    yield put({ type: TRIGGER_ART_DEPT_FAILURE, error: error.message, campaignId: action.payload.campaignId });
  }
}

function* triggerAdVideoSaga(action) {
  try {
    const result = yield call(triggerAdVideoApi, action.payload);
    yield put({ type: TRIGGER_AD_VIDEO_SUCCESS, payload: { ...result, campaignId: action.payload.campaignId } });
  } catch (error) {
    yield put({ type: TRIGGER_AD_VIDEO_FAILURE, error: error.message, campaignId: action.payload.campaignId });
  }
}

function* triggerGoogleAdsCampaignSaga(action) {
  try {
    const result = yield call(triggerGoogleAdsCampaignApi, action.payload);
    yield put({ type: TRIGGER_GOOGLE_ADS_CAMPAIGN_SUCCESS, payload: result });
  } catch (error) {
    yield put({ type: TRIGGER_GOOGLE_ADS_CAMPAIGN_FAILURE, error: error.message });
  }
}

function* publishGoogleAdSaga(action) {
  try {
    const result = yield call(publishGoogleAdApi, action.payload);
    yield put({ type: PUBLISH_GOOGLE_AD_SUCCESS, payload: result });
  } catch (error) {
    yield put({ type: PUBLISH_GOOGLE_AD_FAILURE, error: error.message });
  }
}

function* getGoogleAdStatusSaga(action) {
  try {
    const result = yield call(getGoogleAdStatusApi, action.payload);
    yield put({ type: GET_GOOGLE_AD_STATUS_SUCCESS, payload: result });
  } catch (error) {
    yield put({ type: GET_GOOGLE_AD_STATUS_FAILURE, error: error.message });
  }
}

function* googleAdsOAuthCallbackSaga(action) {
  try {
    const result = yield call(googleAdsOAuthCallbackApi, action.payload);
    yield put({ type: GOOGLE_ADS_OAUTH_CALLBACK_SUCCESS, payload: result });
  } catch (error) {
    yield put({ type: GOOGLE_ADS_OAUTH_CALLBACK_FAILURE, error: error.message });
  }
}

export default function* advertisingAgentSaga() {
  yield takeEvery(GENERATE_AD_CREATIVE_REQUEST,       generateAdCreativeSaga);
  yield takeEvery(PUBLISH_AD_CREATIVE_REQUEST,        publishAdCreativeSaga);
  yield takeEvery(TRIGGER_ART_DEPT_REQUEST,           triggerArtDeptSaga);
  yield takeEvery(TRIGGER_AD_VIDEO_REQUEST,           triggerAdVideoSaga);
  yield takeEvery(TRIGGER_GOOGLE_ADS_CAMPAIGN_REQUEST, triggerGoogleAdsCampaignSaga);
  yield takeEvery(PUBLISH_GOOGLE_AD_REQUEST,          publishGoogleAdSaga);
  yield takeEvery(GET_GOOGLE_AD_STATUS_REQUEST,       getGoogleAdStatusSaga);
  yield takeEvery(GOOGLE_ADS_OAUTH_CALLBACK_REQUEST,  googleAdsOAuthCallbackSaga);
}
